module.exports = __webpack_public_path__ + "img/policy.00852af9.png";